module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAcCAMAAAC5xgRsAAAAclBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9eWEHEAAAAJXRSTlMAwnwOCvj0NSvx4t2woZGKRQbk19PPyqaCeG5rY19OOzomIBYVIXAdRwAAAKpJREFUKM+FUtcSgzAMA8Iuq3vv6v9/sXJLczTOgR+QJXxyYif4CxPuAxWvDXBWagMgyVw1Dikv5678XFCOBkLeyrejWhgrZgV2gtWwOE/JrpIQZ7Z2S7aWRBpmtn1J1jE5/iwucpYTWU28EyviAY0UJ0ApNenHOAKSuDc0xBWQBi0YN7Ka+Oj/+tWvg3Ec/N38J/PfYvTGejp6kqNT1xvS25zavH4l+kW9AR8kGT4c+ax6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/audio.png
// module id = WOPr
// module chunks = 16